import { TIKTOK_DEMOGRAPHICS } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function tiktokDemographicsData(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case TIKTOK_DEMOGRAPHICS:
    
      // const parsedData = JSON.parse(action.payload.data)

      return { ...state, data: action.payload.data, errors: null };
      
    default:
      return state;
  }
}
